import { useCallback, useState } from 'react'
import { useBlocker } from 'lib/hooks/useBlocker'
import AlertDialog from 'components/AlertDialog/AlertDialog'
import { GenericObject } from 'common/types'

interface Props {
  isNavigationBlocked: boolean
  onLeave: () => void
  title?: string
  description?: string
  position?: GenericObject
}

function LeaveDialog({
  isNavigationBlocked,
  onLeave,
  title = 'Leave without adding to list?',
  description = 'Leaving this screen without adding the product to the list will permanently discard the product.',
  position = undefined,
}: Props) {
  const [isLeaveDialogOpen, setIsLeaveDialogOpen] = useState(false)

  const handleBlockedNavigation = useCallback(
    (tx) => {
      if (isNavigationBlocked) {
        setIsLeaveDialogOpen(true)
        return
      }

      tx.retry()
    },
    [isNavigationBlocked]
  )

  const blocker = useBlocker(handleBlockedNavigation, isNavigationBlocked)

  const handleCancel = () => {
    blocker.resetLocation()
    setIsLeaveDialogOpen(false)
  }

  const handleLeave = () => {
    setIsLeaveDialogOpen(false)
    onLeave()
  }

  return (
    <AlertDialog
      isOpen={isLeaveDialogOpen}
      mode="error"
      title={title}
      description={description}
      primaryButtonAction={handleLeave}
      primaryButtonText="Leave"
      secondaryButtonAction={handleCancel}
      secondaryButtonText="Stay"
      zIndex={6}
      isPrimaryDisabled={false}
      isPrimaryLoading={false}
    />
  )
}

export default LeaveDialog
